<template>
  <b-overlay :show="apiRslt.fetch.inProgress" rounded="sm" opacity="0.5" blur="none">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-8 my-2">
            <text-field name="Nom" property="name" v-model="$v.form.name.$model" :error="$v.form.name.$error"
              :isRequired="checkIfRequired($v.form.name)" errorCode="MESS001" />
          </div>
          <div class="col-md-4 my-2">
            <price-field name="Prix" property="sectionPrice" v-model.number="$v.form.price.$model"
              :error="$v.form.price.$error" :isRequired="checkIfRequired($v.form.price)" errorCode="MESS005" />
          </div>
          <comma-caution />
          <div class="col-md-12 my-2">
            <textarea-field name="Description" property="description" length="150" v-model="$v.form.description.$model"
              :error="$v.form.description.$error" :isRequired="checkIfRequired($v.form.description)"
              errorCode="MESS007" />
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="row">
          <preview-field :imageIn="form.image" :folder="menu_url" />
        </div>
        <div class="row">
          <file-field v-model="form.image" :isRequired="checkIfRequired($v.form.image)" :error="$v.form.image.$error"
            name="Photo formule" errorCode="MESS006" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 mt-4">
            <select-tags-field id="menuPart" v-model="$v.form.menuPart.$model" name="Niveaux de formule" index="id"
              text="name" :options="menuParts" :isRequired="checkIfRequired($v.form.menuPart)"
              :error="$v.form.menuPart.$error" errorCode="MESS011">
              <template v-slot:option="{ option }">
                {{ option.name }} <span v-if="option.shortDescription">({{ option.shortDescription }})</span>
              </template>
            </select-tags-field>

          </div>
        </div>
      </div>

      <div class="col-md-12 mt-4">
        <button id="btn-crud-add" class="btn btn-primary float-right" v-show="operation === 'add'"
          style="border-radius: 0;" @click="added">Ajouter</button>
        <button id="btn-crud-update" class="btn btn-primary float-right" v-show="operation === 'update'"
          style="border-radius: 0;" @click="updated">Modifier</button>
        <button id="btn-crud-remove" class="btn float-left bg-danger text-white" v-show="operation === 'update'"
          style="border-radius: 0;" @click="$bvModal.show('confirm-remove')">Supprimer</button>
      </div>

      <b-modal id="confirm-remove" title="Confirmation de suppression" hide-footer hide-header>
        <h5 class="modal-title text-center ">Confirmation de suppression</h5>
        <div class="row d-flex justify-content-center">
          <div class="col-md-12 my-4 text-center">
            <p>
              <small class="text-danger">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                La suppression de la formule, entrainera celle des niveaux qui la compose <br>
              </small>
            </p> 
            <p>
              <span>Êtes-vous sûr de vouloir supprimer cette formule ?</span>
            </p>
              
            
          </div>
          <div class="col-md-5">
            <button id="btn-delete" type="button" class="btn mt-3 btn-outline-success btn-block" @click="deleted(true)">Oui</button>
          </div>
          <div id="btn-no-delete" class="col-md-5">
            <button type="button" class="btn mt-3 btn-outline-danger btn-block" @click="deleted(false)">Non</button>
          </div>
        </div>
      </b-modal>

    </div>
  </b-overlay>
</template>

<script>

import { mapActions, mapState } from "vuex";
import { required, requiredIf, minValue } from 'vuelidate/lib/validators';
import { form, init } from "@/core/mixins";
import { FileField, PreviewField, PriceField, SelectTagsField, TextareaField, TextField } from "@/core/components/form";
import CommaCaution from "@/core/components/common/CommaCaution";

export default {
  name: 'FormMenu',
  components: { FileField, PreviewField, TextField, PriceField, TextareaField, SelectTagsField, CommaCaution },
  mixins: [init, form],
  computed: {
    ...mapState('menus', ['menus', 'apiRslt']),
    ...mapState('menuParts', ['menuParts'])
  },
  data() {
    return {
      show: false,
      form: {
        name: "",
        description: "",
        price: 0,
        image: "",
        menuPart: []
      },
      init: {
        name: "",
        description: "",
        price: 0,
        image: "",
        menuPart: []
      }
    }
  },
  created() {
    this.loadMenuParts()
  },
  methods: {
    added() {
      this.$v.form.$reset()
      this.$v.form.$touch()
      if (!this.$v.form.$error) this.addMenu(this.form)
    },
    updated() {
      this.$v.form.$reset()
      this.$v.form.$touch()
      if (!this.$v.form.$error) this.updateMenu(this.form)
    },
    deleted(confirm) {
      if (confirm) {
        this.$bvModal.hide('confirm-remove')
        this.deleteMenu(this.form.id)
        this.reset(this.form.id)
      } else {
        this.$bvModal.hide('confirm-remove')
      }
    },
    ...mapActions('menus', ['addMenu', 'updateMenu', 'deleteMenu']),
    ...mapActions('menuParts', ['loadMenuParts'])
  },
  validations() {
    return {
      form: {
        name: { required },
        description: { required },
        price: { required, min: minValue(1) },
        menuPart: { },
        image: {
          requiredIf: requiredIf(() => {
            return this.form.image instanceof File || typeof this.form.image === 'string'
          })
        }
      },
    }
  },
}
</script>




